export const timeoutInMinutes = (minutes: number) => {
    const d1 = new Date();
    const d2 = new Date(d1);
    d2.setMinutes(d1.getMinutes() + minutes);
    return d2.getTime();
};

function addLeadingZeroes(n) {
    return n > 9 ? n : '0' + n;
}
